"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var PlayerDetails_module_css_1 = __importDefault(require("./PlayerDetails.module.css"));
var material_1 = require("@mui/material");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var InfoItem = function (_a) {
    var label = _a.label, value = _a.value, t = _a.t;
    return (react_1.default.createElement(material_1.Box, { sx: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            fontSize: "16px",
            width: "80%",
            borderBottom: 1,
            borderColor: "#d2d2d2"
        } },
        react_1.default.createElement(material_1.Box, { component: "span", sx: { color: "#000000", marginRight: "40px" } },
            t(label),
            ":"),
        react_1.default.createElement(material_1.Box, { component: "span", sx: { fontFamily: "Geomanist", color: "#000000", overflow: "hidden", textOverflow: "ellipsis" } }, value)));
};
var PlayerDetailsInfoTab = function (player) {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var playerObject = player.player;
    var onlineValue = playerObject.device_type_id == 1 ? "WEB" : playerObject.is_online ? t("Yes") : t("No");
    var lastSeenDate = new Date(playerObject.player_statuses.updated_at);
    var createdAtDate = new Date(playerObject.player_statuses.updated_at);
    var updatedAtDate = new Date(playerObject.player_statuses.updated_at);
    return (react_1.default.createElement("div", { className: PlayerDetails_module_css_1.default.title },
        react_1.default.createElement("div", { style: { marginBottom: "2rem" }, className: "d-flex justify-content-around" },
            react_1.default.createElement("div", { className: "flex-column d-flex w-50" },
                react_1.default.createElement(material_1.Box, null, t("General")),
                react_1.default.createElement(InfoItem, { label: "ID", value: playerObject.id, t: t }),
                react_1.default.createElement(InfoItem, { label: "Name", value: playerObject.name, t: t }),
                react_1.default.createElement(InfoItem, { label: "Group ID", value: playerObject.player_group_id, t: t }),
                react_1.default.createElement(InfoItem, { label: "Group Name", value: playerObject.player_group.name, t: t }),
                react_1.default.createElement(InfoItem, { label: "Online", value: onlineValue, t: t }),
                react_1.default.createElement(InfoItem, { label: "Last Seen", value: lastSeenDate.toLocaleString(undefined, { hour12: false }), t: t }),
                react_1.default.createElement(InfoItem, { label: "Created By", value: playerObject.created_by, t: t }),
                react_1.default.createElement(InfoItem, { label: "Created At", value: createdAtDate.toLocaleString(undefined, { hour12: false }), t: t }),
                react_1.default.createElement(InfoItem, { label: "Updated At", value: updatedAtDate.toLocaleString(undefined, { hour12: false }), t: t })),
            react_1.default.createElement("div", { className: "flex-column d-flex w-50" },
                react_1.default.createElement(material_1.Box, null, t("Advanced")),
                react_1.default.createElement(InfoItem, { label: "Device Type", value: playerObject.device_type.name, t: t }),
                react_1.default.createElement(InfoItem, { label: "Content Host", value: playerObject.content_host_id, t: t }),
                react_1.default.createElement(InfoItem, { label: "External IP", value: playerObject.player_statuses.ip_address, t: t }),
                react_1.default.createElement(InfoItem, { label: "OS Version", value: playerObject.player_statuses.os_version, t: t }),
                react_1.default.createElement(InfoItem, { label: "Chrome Version", value: playerObject.player_statuses.chrome_version, t: t }),
                react_1.default.createElement(InfoItem, { label: "Q-Play Version", value: playerObject.player_statuses.player_version, t: t }),
                react_1.default.createElement(InfoItem, { label: "Used Memory", value: playerObject.player_statuses.used_memory, t: t }),
                react_1.default.createElement(InfoItem, { label: "Total Memory", value: playerObject.player_statuses.total_memory, t: t })))));
};
exports.default = PlayerDetailsInfoTab;
